/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Modal , Badge , Form , Button , Card , Row , Col , Nav , ProgressBar} from 'react-bootstrap'

class AssignmentType extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };

        this.props.data.isMake = true;
    }

    renderThumbnail(title , description){
        return <Card>
            <Card.Img variant="top" src="https://via.placeholder.com/100" />
            <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Text>{description}</Card.Text>
                <Button block>Select </Button>
            </Card.Body>
        </Card>
    }

    render(){

        return <div>
                <Row>
                    <Col sm={{span: 4, offset: 2}}>{this.renderThumbnail.bind(this)('Existing' , 'select a exiting assignment as a template or choose from the extensive language libary')}
                    </Col><Col sm={{span: 4, offset: 0}}>{this.renderThumbnail.bind(this)('New' , 'Create a comprensive assignment from scratch combining one or many of the languagenut  activities')}
                    </Col>
                </Row>
        </div>;


    }


}


export default {
    name: "Select",
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    onSubmit: function (done){

        done();
    },
    onBack:function(done){
        done();
    },
    component: AssignmentType
}